import { render, staticRenderFns } from "./ChangeTicketDepartmentModal.vue?vue&type=template&id=91cd5aa4&scoped=true&lang=pug&"
import script from "./ChangeTicketDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTicketDepartmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTicketDepartmentModal.vue?vue&type=style&index=0&id=91cd5aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cd5aa4",
  null
  
)

export default component.exports